import { render, staticRenderFns } from "./recent_traffic.vue?vue&type=template&id=2c1ef974&scoped=true&"
import script from "./recent_traffic.vue?vue&type=script&lang=js&"
export * from "./recent_traffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ef974",
  null
  
)

/* custom blocks */
import block0 from "./recent_traffic.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports